<template>
    <div class="home">
        <banner-Component></banner-Component>
        <div class="main">
            <div class="proList wow fadeInUp">
                <div class="item" v-for="(item,index) in pList" :key="index" @click="gotoP(index,item.ID)">
                    <img :src="`https://www.cabling-vivanco.com/upload/${item.PICURL}`" alt="">
                    <div class="info">
                        <p>{{item.CALLED}}</p>
                        <p>{{item.TEXT}}</p>
                        <span>
             <a>Read More</a>
         </span>
                    </div>
                </div>
            </div>
            <div class="threeText wow fadeInUp" ref="counts">
                <div class="item">
                    <div class="t">
                        <span id="num1">5</span>
                        <span style="line-height: 10px;">+</span>
                    </div>
                    <span class="small">Manufacturing Facilities</span>
                </div>
                <div class="item">
                    <div class="t">
                        <span id="num2">30</span>
                        <span style="line-height: 10px;">+</span>
                    </div>
                    <span class="small">Distribution Countries</span>
                </div>
                <div class="item">
                    <div class="t">
                        <span id="num3">4000</span>
                        <span style="line-height: 10px;">+</span>
                    </div>
                    <span class="small">Employees Worldwide</span>
                </div>
                <!--         <img src="../assets/about/yb.png" alt="">-->
            </div>
            <div class="media0 wow fadeInUp">
                <div class="stext">Media Center</div>
                <swiper class="swiper" :options="swiperOption" ref="mySwiper2" v-if="newsList.length>1">
                    <swiper-slide class="item" v-for="(item,index) in newsList" :key="index">
                        <!--                           <img :src="`http://weilishi.sansg.com/upload/${item.SMALLPIC}`" @click="getSrc(item.BIGIMG)" alt="">-->
                        <p @click="goInfo(item.ID)">{{item.TITLE}}</p>
                        <p @click="goInfo(item.ID)">{{item.ZY}}</p>
                        <img :src="`https://www.cabling-vivanco.com//upload/${item.SMALLPIC}`" alt="" @click="goInfo(item.ID)">
                        <p class="time" @click="goInfo(item.ID)">{{item.SHOWTIME}}</p>
                    </swiper-slide>
                </swiper>
                <swiper class="swiper swiper2" :options="swiperOption2" ref="mySwiper3" v-if="newsList.length>1">
                    <swiper-slide class="item" v-for="(item,index) in newsList" :key="index">
                        <!--                           <img :src="`http://weilishi.sansg.com/upload/${item.SMALLPIC}`" @click="getSrc(item.BIGIMG)" alt="">-->
                        <p @click="goInfo(item.ID)">{{item.TITLE}}</p>
                        <p @click="goInfo(item.ID)">{{item.ZY}}</p>
                        <img :src="`https://www.cabling-vivanco.com//upload/${item.SMALLPIC}`" alt="" @click="goInfo(item.ID)">
                        <p class="time" @click="goInfo(item.ID)">{{item.SHOWTIME}}</p>
                    </swiper-slide>
                </swiper>
                <div class="btn prev ">
                    <i class="iconfont icon-yz"></i>
                </div>
                <div class="btn next ">
                    <i class="iconfont icon-yz"></i>
                </div>
            </div>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import bannerComponent from '../components/banner'
    import btnComponent from '../components/btn'
    import Scrollbar from 'smooth-scrollbar'
    import {swiper, swiperSlide} from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import {CountUp} from 'countup.js'
    import footComponent from '../components/foot'
    import '../common/jquery-1.11.3.min'
    import {getNewsUrl, getProductstypeUrl2} from '../util/lang'

    export default {
        name: 'homea',
        data() {
            return {
                swiperOption: {
                    notNextTick: true,
                    slidesPerView: 3,
                    speed: 1000,
                    init: true,
                    loop: true,
                    spaceBetween: 20,
                    autoplay: false,
                    setWrapperSize: true,
                    navigation: {
                        prevEl: '.media0 .btn.prev',
                        nextEl: '.media0 .btn.next',
                    }
                },
                swiperOption2: {
                    notNextTick: true,
                    slidesPerView: 1,
                    speed: 1000,
                    init: true,
                    loop: true,
                    autoplay: false,
                    setWrapperSize: true,
                    spaceBetween: 18,
                    navigation: {
                        prevEl: '.media0 .btn.prev',
                        nextEl: '.media0 .btn.next',
                    }
                },
                newsList: [],
                pList: []
            }
        },
        mounted() {
            Scrollbar.initAll(document.getElementById("scroller-wrapper"));
            let scrollbar = Scrollbar.get(document.getElementById('scroller-wrapper'))
            scrollbar.scrollTo(0, 0)
            this.count()
            this.getNews('24')
            this.getProList()
            this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
            window.pageYOffset = this.scrollbar.scrollTop
            window.pageYOffset = this.scrollbar.scrollTop
            this.scrollbar.addListener(() => {
                // $(".main div").each(function() {
                //     var _this = $(this);
                //     if ($(window).scrollTop() >= $(this).offset().top - $(window).height() + 50)
                //     {
                //         _this.addClass('show');
                //     }else{
                //         _this.removeClass('show');
                //     }
                // });
                window.pageYOffset = this.scrollbar.scrollTop
            });
        },
        components: {bannerComponent, btnComponent, footComponent, swiper, swiperSlide},
        methods: {
            gotoP(n, id) {
                if (n === 0) {
                    const link = `/solution.html?id=${id}`
                    window.open(link, '_blank')
                } else if (n === 1) {
                    const link = `/dataCenter.html?id=${id}`
                    window.open(link, '_blank')
                } else {
                    const link = `/smart.html`
                    window.open(link, '_blank')
                }
            },
            getProList() {
                this.$nextTick(() => {
                    const url = `${getProductstypeUrl2('zh-CN', '42')}`
                    this.$axios.get(url).then(res => {
                        this.pList = res.data
                    })
                })
            },
            getNews(id) {
                const url = `${getNewsUrl('zh-CN', id, 10000, 1)}`
                this.$axios.get(url).then(res => {
                    res.data.newsArr.map((item) => {
                        item.SHOWTIME = item.SHOWTIME.slice(0, 11)
                        if (item.ISCOMMEND === '1')
                            this.newsList.push(item)
                    })
                })
            },
            goInfo(id) {
                const link = `/newsInfo.html?nid=${id}`
                window.open(link)
            },
            count() {
                let element = this.$refs.counts;
                console.log(element)
                let actualTop = element.offsetTop;
                let current = element.offsetParent;
                while (element = element.offsetParent) {
                    actualTop += element.offsetTop;
                    /* current = current.offsetParent; */
                }
                let demoFi1 = new CountUp("num1", 5);
                let demoFi2 = new CountUp("num2", 30);
                let demoFi3 = new CountUp("num3", 4000);
                let demoFi4 = new CountUp("num4", 96);
                let numok = false;
                let scrollbar = Scrollbar.get(document.getElementById('scroller-wrapper'))
                if (scrollbar) {
                    scrollbar.addListener((status) => {
                        if (!numok) {
                            if (actualTop < status.offset.y + document.body.clientHeight) {
                                demoFi1.start();
                                demoFi2.start();
                                demoFi3.start();
                                // demoFi4.start();
                                numok = true;
                            }
                        }
                    });
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .home {
        width: 100%;
        overflow: hidden;
        animation: yd 2s forwards linear;
        @keyframes yd {
            from {
                transform: translateX(20px);
            }
            to {
                transform: translateX(0);
            }
        }

        .main {
            width: 100%;

            .proList {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin: 10px auto;

                .item {
                    width: 33%;
                    position: relative;
                    cursor: pointer;
                    overflow: hidden;
                    height: 490px;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transition: all 1s;
                    }

                    .info {
                        position: absolute;
                        top: 40px;
                        left: 10%;
                        width: 80%;

                        p:nth-child(1) {
                            font-family: "Fira Code Medium";
                            font-size: 30px;
                            text-transform: capitalize;
                            padding-bottom: 20px;
                            transition: all 1s;
                            color: white;
                        }

                        p:nth-child(2) {
                            font-family: book;
                            line-height: 30px;
                            /*color:#919191;*/
                            height: 120px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 4;
                            overflow: hidden;
                            transition: all 1s;
                            color: #d6d6d6;
                        }

                        span {
                            display: inline-block;
                            transition: all 1s;
                            padding: 5px 20px;
                            position: relative;
                            padding-right: 35px;
                            height: 35px;
                            overflow: hidden;
                            width: 100px;

                            a {
                                position: absolute;
                                width: 80%;
                                text-align: center;
                                left: 10%;
                                color: white;
                                line-height: 30px;
                                font-family: book;
                                border-bottom: 1px solid #d3d3d3;
                                transition: all 1s;
                                z-index: 100;
                                padding-bottom: 9px;
                            }
                        }

                        span::before {
                            position: absolute;
                            right: 5%;
                            content: '';
                            display: inline-block;
                            width: 15%;
                            height: 1px;
                            background-color: white;
                            top: 45%;
                            transition: all 600ms;
                            opacity: 0;
                            z-index: 100;
                        }

                        span::after {
                            position: absolute;
                            left: 0;
                            bottom: -60px;
                            content: '';
                            display: inline-block;
                            width: 100%;
                            height: 45px;
                            background-color: #91C131;
                            transition: all 600ms;
                        }
                    }
                }

                .item:hover {
                    img {
                        transform: scale(1.05);
                    }

                    .info {
                        p:nth-child(1) {
                            color: #91C131;
                        }

                        /*p:nth-child(2){*/
                        /*    color:black;*/
                        /*}*/
                        span {
                            a {
                                color: white;
                            }
                        }

                        span::after {
                            bottom: 0;
                        }

                        span::before {
                            opacity: 1;
                        }
                    }
                }
            }

            .threeText {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: center;
                height: 246px;
                background: url("../assets/about/yb.png") no-repeat;
                background-size: 100% 100%;
                margin: 20px auto;
                position: relative;
                overflow: hidden;

                img {
                    position: absolute;
                    left: 0;
                    top: 0;
                    height: 100%;
                    width: 200%;
                    opacity: 0.4;
                    animation: gor 2s linear infinite;
                }

                @keyframes gor {
                    from {
                        transform: translateY(-60px);
                    }
                    to {
                        transform: translateY(0);
                    }
                }

                .item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 20%;
                    margin-top: 50px;
                    text-align: center;

                    .t {
                        position: relative;
                        padding-right: 10px;
                        padding-left: 10px;
                        padding-bottom: 10px;

                        span {
                            font-family: thin;
                        }

                        span:nth-child(1) {
                            font-size: 70px;
                        }

                        span:nth-child(2) {
                            font-size: 50px;
                            position: absolute;
                            top: 0;
                            right: -5px;
                        }
                    }

                    .small {
                        font-family: book;
                        font-size: 20px;
                        color: #444546;
                        text-transform: capitalize;
                    }
                }

                .item:nth-child(1) {
                    .t {
                        span:last-child {
                            top: 0;
                            right: -15px;
                        }
                    }
                }
            }

            .media0 {
                width: 1400px;
                margin: 30px auto;
                position: relative;
                padding-bottom: 100px;

                .stext {
                    text-align: center;
                    font-family: book;
                    text-transform: uppercase;
                    padding-bottom: 60px;
                    font-size: 30px;
                }

                .swiper {
                    width: 100%;

                    .item {
                        cursor: pointer;
                        overflow: hidden;

                        p:nth-child(1) {
                            font-size: 18px;
                            text-transform: capitalize;
                            -webkit-transition: all 1s;
                            transition: all 1s;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            height: 50px;
                            line-height: 30px;
                            position: relative;
                            padding: 15px 0;

                            &::after {
                                display: inline-block;
                                content: '';
                                background-color: black;
                                width: 20%;
                                height: 1px;
                                position: absolute;
                                bottom: 0px;
                                left: 0;
                            }
                        }

                        p:nth-child(2) {
                            color: #8B8B8B;
                            font-family: "Fira Code Medium";
                            font-weight: lighter;
                            margin-top: 10px;
                            margin-bottom: 10px;
                            line-height: 30px;
                            /*padding-bottom: 20px;*/
                            transition: all 1s;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            height: 60px;
                            font-size: 14px;
                        }

                        img {
                            transition: all 1s;
                            object-fit: contain;
                            height: 267px;
                        }

                        .time {
                            text-align: right;
                            color: #AFAFAF;
                            font-family: book;
                            font-size: 14px;
                            margin-top: 10px;
                            transition: all 1s;
                        }
                    }

                    .swiper-slide {
                        img {
                            transition: all 2s;
                            animation-delay: 2s;
                            width: 100%;
                        }
                    }

                    .item:hover {
                        p:nth-child(1) {
                            color: #91C131;
                        }

                        p:nth-child(2), .time {
                            color: black;
                        }

                        img {
                            transform: scale(1.05);
                        }
                    }

                    /*.swiper-slide-active{*/
                    /*    width:600px !important;*/
                    /*    img{*/
                    /*        height:431px;*/
                    /*        object-fit: cover;*/
                    /*    }*/
                    /*    p{*/
                    /*        text-align: right;*/
                    /*    }*/
                    /*    p:nth-child(1){*/
                    /*        font-family: book;*/
                    /*        font-size: 20px;*/
                    /*    }*/
                    /*    p:nth-child(2){*/
                    /*        width:60%;*/
                    /*        margin-left: 40%;*/
                    /*    }*/
                    /*    .time{*/
                    /*        display: none;*/
                    /*    }*/
                    /*}*/
                    /*.swiper-slide-duplicate-prev{*/
                    /*    .time{*/
                    /*        text-align: left;*/
                    /*    }*/
                    /*}*/
                }

                .swiper2 {
                    display: none;
                }

                .prev {
                    position: absolute;
                    bottom: 40%;
                    left: -4%;
                    padding: 5px 5px;
                    color: #8B8B8B;
                    cursor: pointer;
                    transform: rotate(180deg);
                    transition: all 2s;
                    z-index: 1000;

                    i {
                        font-size: 30px;
                    }
                }

                .next {
                    position: absolute;
                    bottom: 40%;
                    right: -4%;
                    color: #8B8B8B;
                    padding: 5px 5px;
                    cursor: pointer;
                    transition: all 2s;
                    z-index: 1000;

                    i {
                        font-size: 30px;
                    }
                }

                .btn:hover {
                    color: #91C131;
                }

                .btn:focus {
                    outline: none;
                }
            }
        }

        @media screen and (max-width: 1440px) {
            .main {
                .proList {
                    .item {
                        height: 420px;
                    }
                }

                .media0 {
                    width: 90%;

                    .swiper {

                    }

                    .prev {
                        left: -40px;
                        bottom: 35%;
                    }

                    .next {
                        right: -40px;
                        bottom: 35%;

                    }
                }
            }
        }
        @media screen and (max-width: 1399px) and (min-width: 1000px) {
            //    .main{
            //        .media{
            //            width:95%;
            //        }
            //    }
        }
        @media screen and (max-width: 999px) {
            .main {
                width: 95%;
                margin-left: 2.5%;

                .proList {
                    flex-direction: column;

                    .item {
                        width: 100%;
                        height: 300px;
                        margin-top: 30px;
                    }
                }

                .threeText {
                    justify-content: space-between;
                    height: 200px;

                    .item {
                        width: 33%;
                        margin-top: 40px;

                        .t {
                            span:nth-child(1) {
                                font-size: 50px;
                            }
                        }

                        .small {
                            font-size: 16px;
                        }
                    }
                }

                .media0 {
                    height: 550px;
                    width: 95%;

                    .swiper {
                        display: none;
                    }

                    .swiper2 {
                        display: block;
                        /*.swiper-slide-active{*/
                        /*    width:366px !important;*/
                        /*    img{*/
                        /*        height:300px;*/
                        /*        object-fit: cover;*/
                        /*    }*/
                        /*    p{*/
                        /*        text-align: right;*/
                        /*    }*/
                        /*    p:nth-child(2){*/
                        /*        width:97%;*/
                        /*        margin-left: 0;*/
                        /*    }*/
                        /*    .time{*/
                        /*        display: none;*/
                        /*    }*/
                        /*}*/
                        /*.swiper-slide-duplicate-prev{*/
                        /*    .time{*/
                        /*        text-align: left;*/
                        /*    }*/
                        /*}*/
                    }

                    .btn {
                        bottom: 6%;
                    }

                    .next {
                        left: 23%;
                    }

                    .btn {
                        -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1000px) {
        .home {
            .main {
                .media0 {
                    .swiper2 {
                        .item {
                            p:nth-child(1) {
                                font-size: 12px;
                            }
                        }
                    }

                    .prev {
                        left: -7%;
                    }

                    .prev, .next {
                        bottom: 40%;
                    }

                    .next {
                        left: 95%;
                    }
                }

                .proList {
                    .item {
                        .info {
                            p:nth-child(2){
                                display: none;
                            }
                            span{
                                margin-top: 60px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
